import React from 'react';
interface LogoMarkProps {
  size?: 'sm' | 'md' | 'lg';
  variant?: 'light' | 'dark';
}
export function LogoMark({
  size = 'md',
  variant = 'light'
}: LogoMarkProps) {
  const sizeClasses = {
    sm: 'w-8 h-8 text-xs',
    md: 'w-12 h-12 text-sm',
    lg: 'w-16 h-16 text-base'
  };
  // 'dark' = used on dark backgrounds (nav/footer): white bg, navy text
  // 'light' = used on light backgrounds: navy bg, white text
  const bgClasses = variant === 'dark' ? 'bg-white text-navy-900 border-white/20' : 'bg-navy-900 text-white border-navy-700';
  return <div className={`flex flex-col items-center justify-center rounded-sm font-bold border ${sizeClasses[size]} ${bgClasses}`} data-id="element-259">
      <span className="leading-none tracking-tight" data-id="element-260">CG</span>
    </div>;
}